import React from "react";

import { useAppDispatch, useAppSelector } from "store";
import { hideFilters, selectFiltersVisibility, setCandidateStore } from "modules/customer/insights/cost/filters/filtersSlice";
import { CostChapter, selectCurrentChapter, selectSelectedStoreByCostType } from "modules/customer/insights/cost/costSlice";

import TwoPanelDialog, { JustifyContent } from "components/TwoPanelDialog";

import Actions from "./Actions";
import Content from "./Content";
import SelectedStoreOpen from "./SelectedStoreOpen";
import Stepper from "./Stepper";
import Title from "./Title";

const Filters: React.FC = () => {
    const dispatch = useAppDispatch();
    const currentChapter = useAppSelector(selectCurrentChapter);
    const filtersVisibility = useAppSelector(selectFiltersVisibility);
    const selectedStoreByCostType = useAppSelector(selectSelectedStoreByCostType);
    const isVisible = filtersVisibility.isVisible;

    const handleClose = () => {
        dispatch(hideFilters());
    };

    React.useEffect(() => {
        if (isVisible) {
            dispatch(setCandidateStore(selectedStoreByCostType));
        }
    }, [dispatch, isVisible, selectedStoreByCostType]);

    return (
        <>
            {(currentChapter === CostChapter.StoreCosts || currentChapter === CostChapter.StoreCostActions) && (<SelectedStoreOpen />)}
            <TwoPanelDialog
                open={isVisible}
                onClose={handleClose}
                leftPanelTitle={<Title />}
                leftPanelContent={<Stepper />}
                leftPanelActions={<Actions />}
                leftPanelActionsJustifyContent={JustifyContent.SpaceBetween}
                rightPanelContent={<Content />}
            />
        </>
    );
};

export default Filters;
